import type { AppEnvironment } from '../app/core/app-environment';

export const environment: AppEnvironment = {
  production: true,
  apiBaseUrl: '',
  firebaseTrampolineUrl: 'https://fruitage-6dd9a.firebaseapp.com/firebase-trampoline.html',
  firebase: {
    apiKey: "AIzaSyA8h0_7SOcc56MtBF2sQjSUPw3z1IRO9zU",
    authDomain: "fruitage-6dd9a.firebaseapp.com",
    projectId: "fruitage-6dd9a",
    storageBucket: "fruitage-6dd9a.firebasestorage.app",
    messagingSenderId: "384851311396",
    appId: "1:384851311396:web:5ccd39d45b21d7e0e651b1"
  }
};
